// extracted by mini-css-extract-plugin
export var headerXL = "HeroSection-module--headerXL--IMy8g";
export var headerL = "HeroSection-module--headerL--1kVkt";
export var headerM = "HeroSection-module--headerM--3AoEx";
export var headerS = "HeroSection-module--headerS--1lT13";
export var headerXS = "HeroSection-module--headerXS--4fGop";
export var blogHeaderXL = "HeroSection-module--blogHeaderXL--1fHn8";
export var blogHeaderL = "HeroSection-module--blogHeaderL--22GUt";
export var blogHeaderM = "HeroSection-module--blogHeaderM--ERGLp";
export var blogHeaderS = "HeroSection-module--blogHeaderS--2gR4I";
export var blogHeaderXS = "HeroSection-module--blogHeaderXS--2ObW4";
export var headerPreamble = "HeroSection-module--headerPreamble--1WT20";
export var preHeader = "HeroSection-module--preHeader--1tf2A";
export var textNormal = "HeroSection-module--textNormal--H4DRc";
export var textSmall = "HeroSection-module--textSmall--1SfsT";
export var textSmallAlternate = "HeroSection-module--textSmallAlternate--itQJc";
export var legend = "HeroSection-module--legend--1rOE3";
export var caption = "HeroSection-module--caption--1cXeY";
export var gradientBackground = "HeroSection-module--gradientBackground--3UmuL";
export var ellipsis = "HeroSection-module--ellipsis--2vaUa";
export var globalContainer = "HeroSection-module--globalContainer--2IWqy";
export var maxWidth = "HeroSection-module--maxWidth--gdlSC";
export var clipBottom = "HeroSection-module--clipBottom--2DBZt";
export var clipTopBottom = "HeroSection-module--clipTopBottom--3jq-s";
export var container = "HeroSection-module--container--MnmtD";
export var contentRow = "HeroSection-module--contentRow--2ovxp";
export var ch2 = "HeroSection-module--ch2--1J-g-";
export var ch2Container = "HeroSection-module--ch2-container--2A0Hk";